/* eslint-disable */
export default {
  get_pickup_locations: (state) => state.pickupLocations,
  get_pickup_location_by_id: (state) => (id) => state.pickupLocations.find((opt) => opt.id === id),
  get_single_pickup: (state) => state.singlePickup,
  get_booked_pickup_list: (state) => state.bookedPickupList.items,
  get_booked_pickup_count: (state) => state.bookedPickupList.count,
  get_not_planned_pickup_list: (state) => state.notPlannedPickupList.items,
  get_not_planned_pickup_count: (state) => state.notPlannedPickupList.count,
  get_pickup_shipments_list: (state) => state.pickupShipmentsList.items,
  get_pickup_shipments_count: (state) => state.pickupShipmentsList.count,
  get_pickup_allowed_freight_products: (state) => state.pickupAllowedFreightProducts,
  get_pickup_shipment_by_id: (state) => (id) => {
    return state.pickupShipmentsList.items.filter((shipment) => shipment.id == id)[0]
  },
};
